export const DB_NAME = 'hotel_db';
export const STORE_NAME = 'utils';
export const DB_VERSION = 1;